import schedulesViewStateStore from "../../store/store";
import { IShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";

export default mutatorAction('SET_SHIFTS_IN_VIEW', function setShiftsInView(
    shiftsInView: IShiftEntity[],
    viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
) {
    const store = viewState ? viewState : schedulesViewStateStore();
    store.shiftsInView.clear();
    if (shiftsInView && shiftsInView.length) {
        for (let i = 0; i < shiftsInView.length; i++) {
            store.shiftsInView.set(shiftsInView[i].id, shiftsInView[i]);
        }
    }
});
